module.exports = __webpack_public_path__ + "static/media/pigo_6.cb74249f.png";